import { api } from '../../api/api';
import apiError from '../../api/api-error';

// initial state
const state = {
   rec:null
};

// getters
const getters = {
};

// actions
const actions = {
   OVERLAY_GET:(context, {id})=>{
      return new Promise((resolve, reject)=>{
         api.get('/api/overlays/'+ id)
         .then((res)=>{
            context.commit('OVERLAY_SET', {rec: res.data});
            resolve();
         })
         .catch((error)=>{
            context.commit('ERROR_MESSAGE_SET',{message:apiError.message('overlay',error)});
            reject(error);
         });
      });
   },
   OVERLAY_HIGHLIGHT:(context, {})=>{
      const obj = {
         styleLayer: 'overlays',
         source: 'scoutred',
         sourceLayer: 'overlays',
         id:state.rec.id,
      };
      context.commit('MAP_FEATURE_ACTIVE_SET', obj);
   },
   OVERLAY_HIGHLIGHT_CLEAR:(context, {})=>{
      context.commit('MAP_FEATURE_ACTIVE_SET', null);
   },
   OVERLAY_REFERENCE_ADD:async (context, {id, reference, sourceId, layerId})=>{
      const add = {...reference, layerId:Number(layerId), sourceId:Number(sourceId)};
      const res = await api.post('/api/layer-references', add);
      context.dispatch('OVERLAY_GET',{id});
   },
   OVERLAY_REFERENCE_DELETE:async (context, {id, referenceId})=>{
      const res = await api.delete('/api/layer-references/'+referenceId);
      context.dispatch('OVERLAY_GET',{id});
   },
   OVERLAY_REFERENCE_SAVE:async (context, {id, reference, referenceId})=>{
      const res = await api.put('/api/layer-references/'+referenceId, reference);
      context.dispatch('OVERLAY_GET',{id});
   },
   OVERLAY_SAVE:async (context, {id, rec})=>{
      const res = await api.put('/api/overlays/'+ id, rec);
      context.commit('OVERLAY_SET',{rec:rec});
   },
   OVERLAY_VISIBLE:function(context, overlay){
      overlay = overlay || state.rec;

      let features = [];

      if (overlay.sourceLayer){
         features.push({
            sourceLayer:'overlays',
            properties:{
               layer_id: overlay.sourceLayer.layerId,
               source_id: overlay.sourceLayer.sourceId
            }
         });
      }
      features.push({
         sourceLayer:'overlay_labels',
         properties:{
            resource_id: overlay.id
         }
      });

      context.commit('MAP_FEATURE_VISIBLE_ON',features);
   },
   OVERLAY_VISIBLE_CLEAR:function(context, overlay){
      context.commit('MAP_FEATURE_VISIBLE_CLEAR','all');
   },
   OVERLAY_ZOOM_TO:(context, {coords})=>{
      let centerX, centerY;

      if(coords && coords.lng && coords.lat){
         centerX = coords.lng; 
         centerY = coords.lat;
      } else {
         if (!state.rec || !state.rec.bounds || !state.rec.bounds.bbox) return;
         const bbox = state.rec.bounds.bbox;
         centerX = bbox[0] + (bbox[2] - bbox[0])/2;
         centerY = bbox[1] + (bbox[3] - bbox[1])/2;
      }

      context.commit('MAP_FLY_TO', {
         center: [centerX, centerY],
         zoom: 13
      });
   },
};

// mutations
const mutations = {
   OVERLAY_SET:(state,{rec})=>{
      state.rec = rec;
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/overlay.js